export default __webpack_public_path__ + "c13f0293c3c8a3584eea42af890d9feb.png";